export const deleteCursor = "url('/storage/images/icons/delete-cursor.png'), pointer";
